import * as React from "react";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import { Icon } from "@iconify/react";

export default function ProgressMobileStepper({
  handleBack,
  handleNext,
  activeStep,
  steps,
  lastStep,
  allowNext,
}) {
  return (
    <MobileStepper
      variant="progress"
      steps={steps}
      position="static"
      activeStep={activeStep}
      sx={{ flexGrow: 1 }}
      nextButton={
        <Button
          size="small"
          variant="contained"
          color={lastStep ? "error" : "secondary"}
          onClick={handleNext}
          disabled={!allowNext}
          // disabled={activeStep !== steps - 1}
        >
          {lastStep ? "Beenden" : "Weiter"}
          {!lastStep && (
            <Icon
              icon="material-symbols:keyboard-arrow-right"
              width="24"
              height="24"
            />
          )}
        </Button>
      }
      backButton={
        <Button
          size="small"
          onClick={handleBack}
          disabled={activeStep === 0 || lastStep}
        >
          <Icon
            icon="material-symbols:keyboard-arrow-left"
            width="24"
            height="24"
          />
          Zurück
        </Button>
      }
    />
  );
}
